// The orderbook layout picker (Tab / Stacked / Large), split out of
// TradeOrderbookSection to keep that file within the file-size budget.
import { LAYER_COLORS } from "../../../constants/design/colors";
import Dropdown from "../../shared/Dropdown";
import DotsVerticalIcon from "./DotsVerticalIcon";
import { OrderbookLayoutEnum } from "./shared";
import { LayoutDropdownItem, LayoutMenuButton } from "./style";

interface LayoutDropdownProps {
  layout: OrderbookLayoutEnum;
  setLayout: (layout: OrderbookLayoutEnum) => void;
  onToggle: () => void;
}

const OPTIONS: { label: string; value: OrderbookLayoutEnum }[] = [
  { label: "Tab", value: OrderbookLayoutEnum.TAB },
  { label: "Stacked", value: OrderbookLayoutEnum.STACKED },
  { label: "Large", value: OrderbookLayoutEnum.LARGE },
];

function LayoutDropdown({ layout, setLayout, onToggle }: LayoutDropdownProps) {
  return (
    <Dropdown
      onToggle={onToggle}
      dropdownMenuContainerStyles={{
        backgroundColor: LAYER_COLORS.four,
        minWidth: 100,
      }}
      toggleStyles={{ padding: 0, backgroundColor: "transparent" }}
      title={
        <LayoutMenuButton as="span">
          <DotsVerticalIcon />
          {/* The toggle is icon-only; this is its accessible name (Bootstrap's
              global .visually-hidden, since the shared Dropdown is at its size budget). */}
          <span className="visually-hidden">Order book layout</span>
        </LayoutMenuButton>
      }
      items={OPTIONS.map((opt) => ({
        label: (
          <LayoutDropdownItem active={layout === opt.value}>
            {opt.label}
          </LayoutDropdownItem>
        ),
        onSelect: () => setLayout(opt.value),
      }))}
    />
  );
}

export default LayoutDropdown;
